// @flow

import * as React from 'react';
import Swipeable from 'react-swipeable';
import IndicatorDots from '@ta/common.indicator-dots';
import { getHeader, getContent } from './text';
import styles from './MobileValuePropositionSkeleton.less';

type State = {
  currentIndex: number,
};

type Props = {
  startIndex: number,
};

/* We have 3 slides in total */
const numOfSlides = 3;

const maxIndex = 2;

const minIndex = 0;

class MobileValuePropositionSkeleton extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      currentIndex: this.props.startIndex,
    };
    this.swipeToRight = this.swipeToRight.bind(this);
    this.swipeToLeft = this.swipeToLeft.bind(this);
  }

  swipeToRight = () => {
    let currentIndex = this.state.currentIndex - 1;
    if (currentIndex < minIndex) currentIndex = maxIndex;
    this.setState({
      currentIndex,
    });
  };

  swipeToLeft = () => {
    let currentIndex = this.state.currentIndex + 1;
    if (currentIndex > maxIndex) currentIndex = minIndex;
    this.setState({
      currentIndex,
    });
  };

  render() {
    return (
      <Swipeable key="swipeable" onSwipedRight={this.swipeToRight} onSwipedLeft={this.swipeToLeft}>
        <div key={this.state.currentIndex} className={styles.mobile_slide}>
          <div className={styles.header}>{getHeader(this.state.currentIndex)}</div>
          <div className={styles.content}>{getContent(this.state.currentIndex)}</div>
        </div>
        <IndicatorDots
          numDots={numOfSlides}
          numItems={numOfSlides}
          currentIndex={this.state.currentIndex}
          whiteBackground
        />
      </Swipeable>
    );
  }
}

export default MobileValuePropositionSkeleton;
